// UI texts: choice events during expeditions (6.1)
export default {
  title: 'Something happened out there',
  later: 'Later',
  left: '{s}s to decide · then: {option}',
  /** Package 4, part B: a decision in the middle of a long run (the run goes on). */
  leftDecision: '{t} to decide · then: {option} · your survivor keeps going meanwhile',
  timeUp: 'Time is up. Your survivor decides.',
  chance: '{n}% ({stat})',
  chanceFlat: '{n}% chance',
  /** 28. 10. 2026 (player report): a cost is paid from the pack only (`canPay`); a delivery out of Storage is `fromStorage`. */
  cost: 'Costs {what} from your pack',
  fromStorage: '{what} from Storage',
  safe: 'Safe',
  default: 'If you wait',
} as const;
